import { CAPI_GA4_MEASUREMENT_ID } from '@/config/analytics';

import { fbClickIdFromAdClick, linkedInClickIdFromAdClick } from './adClicks';
import { readConsent } from './cookiebot';
import { readCookie } from './cookies';
import { readGaClientId, readGaSessionId } from './googleAnalytics';

export const HELPCRUNCH_ATTRIBUTES = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'fbp',
  'fbc',
  'li_fat_id',
  'ga_client_id',
  'ga_session_id',
  'page_url',
  'consent_marketing',
  'consent_statistics',
] as const;

type HelpCrunchAttribute = (typeof HELPCRUNCH_ATTRIBUTES)[number];

export type HelpCrunchCustomData = Partial<Record<HelpCrunchAttribute, string>>;

const compact = (
  data: Record<HelpCrunchAttribute, string>,
): HelpCrunchCustomData => {
  const customData: HelpCrunchCustomData = {};

  HELPCRUNCH_ATTRIBUTES.forEach((key) => {
    if (data[key]) customData[key] = data[key];
  });

  return customData;
};

export const collectHelpCrunchCustomData = (): HelpCrunchCustomData => {
  const params = new URLSearchParams(window.location.search);

  return compact({
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc') || fbClickIdFromAdClick(),
    li_fat_id: readCookie('li_fat_id') || linkedInClickIdFromAdClick(),
    ga_client_id: readGaClientId(),
    ga_session_id: readGaSessionId(CAPI_GA4_MEASUREMENT_ID),
    page_url: window.location.href,
    ...readConsent(),
  });
};
